import { render, staticRenderFns } from "./shoppingMail.vue?vue&type=template&id=8e865f26&scoped=true&"
import script from "./shoppingMail.vue?vue&type=script&lang=js&"
export * from "./shoppingMail.vue?vue&type=script&lang=js&"
import style0 from "./shoppingMail.vue?vue&type=style&index=0&id=8e865f26&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e865f26",
  null
  
)

export default component.exports